
import React, { useEffect, useState, useMemo } from 'react';
import { Col, Container, Row } from 'react-bootstrap';
import AuthNavbar from '../components/AuthNavbar/AuthNavbar';
import HomeTitle from '../components/HomeTitle/HomeTitle';
import { useDispatch, useSelector } from 'react-redux';
import Table from "../components/Table/Table";
import { useNavigate } from 'react-router-dom';
import { fetchStudents } from '../hooks/students';
import CustomBtn from '../components/CustomBtn/CustomBtn';
  import * as XLSX from "xlsx";
import { saveAs } from "file-saver";

function StudentsExpenses() {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const { currentLocal } = useSelector((state) => state.currentLocal);
  const { list: items } = useSelector((state) => state.Students);
  const [searchText, setSearchText] = useState("");

  useEffect(() => {
    dispatch(fetchStudents());
  }, []);

  // تجميع البيانات بحيث يتم أخذ الرؤوس من details والبيانات من payments
  // const result = useMemo(() => {
  //   const grouped = {};
  //   items.forEach((item) => {
  //     const studentId = item.student.id;
  //     if (!grouped[studentId]) {
  //       grouped[studentId] = {
  //         student: item.student,
  //         details: [], // لاستخراج الرؤوس
  //         payments: [], // لتعبئة الجسم
  //         amount_due: item.amount_due,
  //         cumulative_paid: item.cumulative_paid,
  //         expense_price: item.expense_price,
  //       };
  //     }

      
  //     // إضافة الدفعة الحالية للمصفوفة
  //     grouped[studentId].payments.push({
  //       amount_paid: item.amount_paid,
  //       created_at: item.created_at,
  //       is_registration_fee: item.is_registration_fee,
  //       // ربط الدفعة باسم البند لضمان وضعها في العمود الصحيح
  //       payment_type: item.details?.[0]?.name 
  //     });

  //     // جمع أسماء البنود الفريدة للرؤوس
  //     item.details?.forEach((detail) => {
  //       const exists = grouped[studentId].details.find(d => d.name === detail.name);
  //       if (!exists) {
  //         grouped[studentId].details.push({ name: detail.name });
  //       }
  //     });
  //   });
  //   return Object.values(grouped);
  // }, [items]);




  const result = useMemo(() => {
  const grouped = {};
  items?.student_expenses?.data?.forEach((item) => {
    const studentId = item.student.id;
    if (!grouped[studentId]) {
      grouped[studentId] = {
        student: item.student,
        grade:item?.grade?.name,
        grade_category:item?.grade?.grade_category?.name,
        details: [],
        payments: [],
        amount_due: item.amount_due,
        cumulative_paid: item.cumulative_paid,
        expense_price: item.expense_price,
      };
    }

    grouped[studentId].payments.push({
      amount_paid: item.amount_paid,
      created_at: item.created_at,
      is_registration_fee: item.is_registration_fee,
      payment_type: item.details?.[0]?.name
    });

    item.details?.forEach((detail) => {
      const exists = grouped[studentId].details.find(d => d.name === detail.name);
      if (!exists) {
        grouped[studentId].details.push({ name: detail.name });
      }
    });
  });

  // عكس الدفعات لكل طالب
  Object.values(grouped).forEach(student => {
    student.payments.sort((a, b) => new Date(a.created_at) - new Date(b.created_at));
    // لو عايزة بالعكس خالص:
    student.payments.reverse();
  });

  return Object.values(grouped);
}, [items.student_expenses]);
  

  const detailNames = [...new Set(result.flatMap(s => s.details.map(d => d.name)))];

  const headerIterm = [
    currentLocal.home.ID,
    currentLocal.home.namePlaceholder,
    currentLocal.home.Stage,
    currentLocal.home.grade,
    ...detailNames, // الرؤوس من الـ Details
    currentLocal.home.RemainingPrice,
    currentLocal.home.amount_paid,
    currentLocal.home.Total,
    "",
  ];
const alldata = [...(result || []), ...(items?.recently_created_students || [])];
console.log(alldata,"alldata");

  const body = (
    <tbody>
      {alldata?.map((item, index) =>{
        
        console.log(item);
        
        return(
        <tr key={index}>
          <td>{item.student?item?.student?.id:item.id}</td>
          <td style={{ minWidth: "150px" }}>{item.student?item.student?.name:item?.name}</td>
          <td>{item?.grade_category?item?.grade_category:item?.grade?.grade_category?.name || "---"}</td>
          <td>{item?.grade?.name?item?.grade?.name:item?.grade || "---"}</td>

{detailNames.map((headerName, idx) => {
const currentPayment = item?.payments?.[idx];
  return (
    <td key={idx} className="text-center p-0" style={{ minWidth: "120px", borderRight: "1px solid #eee" }}>
      {currentPayment ? (
        <div 
          className="px-2 py-2 h-100 d-flex flex-column justify-content-center"
          style={{ backgroundColor: currentPayment.is_registration_fee ? "#f0fff4" : "transparent" }}
        >
          <span className="fw-bold text-success">{currentPayment.amount_paid}</span>
          <div style={{ fontSize: "10px", color: "#888" }}>
            {currentPayment.created_at} 
          </div>
        </div>
      ) : (
        <span className="text-muted" style={{ opacity: 0.3 }}>---</span>
      )}
    </td>
  );
})}

          <td className="fw-bold text-danger">{item.amount_due}</td>
          <td className="fw-bold text-primary">{item.cumulative_paid}</td>
          <td>{item.expense_price}</td>
          <td>
            <button className='btn btn-sm btn-outline-info mx-2' 
             onClick={() => navigate(!item.student?`/payment/${item.student?item.student.id:item?.id}/${item?.grade?.id }`:`/dashboard/student/Finance/${item.student?item.student.id:item?.id}/${item?.grade?.name?item?.grade?.name:item?.student?.grade_id }`)}>
              {currentLocal.home.Academicyearexpenses}
            </button> 
            {/* <button className='btn btn-sm btn-outline-info' onClick={() => navigate(`/dashboard/student/${item.student?item.student.id:item.id}`)}>
              {currentLocal.home.Preview}
            </button> */}
            {/* {item?.payments!=undefined&&item?.payments.find((item)=>item?.is_registration_fee==1)&&item?.cumulative_paid!=item?.expense_price&&
            <> */}
         {/* <button className='btn btn-sm btn-outline-info mx-2' 
             onClick={() => navigate(`/dashboard/student/Finance/${item.student?item.student.id:item?.id}/${item?.grade?.name?item?.grade?.name:item?.student?.grade_id }`)}>
              {currentLocal.home.Academicyearexpenses}
            </button>   */}
      
            {/* {!item.student&&     
             <button className='btn btn-sm btn-outline-info mx-2' 
             onClick={() => navigate(!item.student?`/payment/${item.student?item.student.id:item?.id}/${item?.grade?.id }`:`/dashboard/student/Finance/${item.student?item.student.id:item?.id}/${item?.grade?.name?item?.grade?.name:item?.student?.grade_id }`)}>
              {currentLocal.home.Academicyearexpenses}
            </button>
} */}
          </td>
        </tr>
      )})}
    </tbody>
  );




  return (
    // استخدام container-fluid و w-100 لضمان ملء الشاشة
    <div className="w-100" style={{ minHeight: "100vh", backgroundColor: "#f8f9fa" }}>
      <Container fluid className="px-4"> 
        <AuthNavbar />
        <div className="mt-4">
            {/* <HomeTitle title={currentLocal.home.students} /> */}
            <div className="d-flex justify-content-between align-items-center mb-4">
  <HomeTitle title={currentLocal.home.students} />
  <div>
    <input
      className='form-control'
      style={{ width: "300px", display: "inline-block", marginRight: "10px" }}
      placeholder={currentLocal.home.search}
      value={searchText}
      onChange={(e) => setSearchText(e.target.value)}
    />
    <button 
  className="btn btn-sm btn-outline-primary mx-4"
  onClick={() => window.print()}
    >
<svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" class="bi bi-printer" viewBox="0 0 16 16">
  <path d="M2.5 8a.5.5 0 1 0 0-1 .5.5 0 0 0 0 1"/>
  <path d="M5 1a2 2 0 0 0-2 2v2H2a2 2 0 0 0-2 2v3a2 2 0 0 0 2 2h1v1a2 2 0 0 0 2 2h6a2 2 0 0 0 2-2v-1h1a2 2 0 0 0 2-2V7a2 2 0 0 0-2-2h-1V3a2 2 0 0 0-2-2zM4 3a1 1 0 0 1 1-1h6a1 1 0 0 1 1 1v2H4zm1 5a2 2 0 0 0-2 2v1H2a1 1 0 0 1-1-1V7a1 1 0 0 1 1-1h12a1 1 0 0 1 1 1v3a1 1 0 0 1-1 1h-1v-1a2 2 0 0 0-2-2zm7 2v3a1 1 0 0 1-1 1H5a1 1 0 0 1-1-1v-3a1 1 0 0 1 1-1h6a1 1 0 0 1 1 1"/>
</svg>    </button>


  </div>

</div>
<div>
<Row>
    <Col md={6}></Col>
              <Col md={6}>
              <div className='d-flex justify-content-end'>
                <div className='w-50 d-flex justify-content-start mb-3'>
                  <CustomBtn text={currentLocal.home.add} clickingFunction={()=>navigate("/choose-stage")} />

                </div>
              </div>
            </Col>
</Row>
</div>

          {/* الحاوية التي تضمن ظهور الـ Scrollbar بشكل صحيح للجدول العريض */}
            <div id="printable-table" className="table-responsive shadow-sm bg-white rounded">

            <Table
              data={result}
              headerIterm={headerIterm}
              actions={["edit"]}
              body={body}
            />
          </div>
        </div>
      </Container>
    </div>
  );
}

export default StudentsExpenses;